/**
 * PATH: packages/ui/src/components/email/dateUtils.ts
 * PURPOSE:
 *   - Date formatting helpers used by the universal email
 *     primitives. Kept narrow to the inbox/list use-case;
 *     full-precision formatting is handled by the host's own
 *     locale stack.
 *
 * ROLE IN ARCHITECTURE:
 *   - Lifted from `apps/sam/src/features/email/lib/utils.ts`
 *     by Stack 6 PR 2b. The inbox-relative formatter
 *     (`formatRelativeDate`) is the only piece consumed by
 *     `<EmailRow>`. Other helpers in the SAM file
 *     (`formatFullDate`, `formatFileSize`, etc.) stay app-local
 *     for now until a real consumer lifts them.
 *   - Pre-import history:
 *     https://gitlab.com/vast-dreams/all-styled-steel-dashboard/-/blame/main/frontend/src/features/email/lib/utils.ts
 */

/** Inbox-list date formatter: "10:23 AM" today, "Mon" this week,
 *  "Apr 12" otherwise. Locale-aware via Intl. */
export function formatRelativeDate(iso: string): string {
  if (!iso) return ''
  const d = new Date(iso)
  const now = new Date()
  const diff = now.getTime() - d.getTime()
  if (diff < 86_400_000 && d.getDate() === now.getDate()) {
    return d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
  }
  if (diff < 604_800_000) {
    return d.toLocaleDateString([], { weekday: 'short' })
  }
  return d.toLocaleDateString([], { month: 'short', day: 'numeric' })
}
